import { frontendURL } from 'dashboard/helper/URLHelper';
import OrganizationsIndex from './pages/OrganizationsIndex.vue';

const organizationsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/organizations'),
      name: 'organizations_index',
      meta: {
        permissions: ['administrator'],
      },
      component: OrganizationsIndex,
    },
  ],
};

export default organizationsRoutes;
